
(function() {
  var result = { translations: { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min", "days": "{{ days }}\xA0jours", "shortForm": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0m", "hours": "{{ hours }}\xA0h", "days": "{{ days }}\xA0j", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.784"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.784",
    "ar-eg": "static-7.784",
    "bg": "static-7.784",
    "bn": "static-7.784",
    "ca-es": "static-7.784",
    "cs": "static-7.784",
    "da": "static-7.784",
    "de": "static-7.784",
    "el": "static-7.784",
    "en-gb": "static-7.784",
    "en": "static-7.784",
    "es-mx": "static-7.784",
    "es": "static-7.784",
    "fi": "static-7.784",
    "fr-ca": "static-7.784",
    "fr": "static-7.784",
    "he-il": "static-7.784",
    "hr": "static-7.784",
    "hu": "static-7.784",
    "id": "static-7.784",
    "it": "static-7.784",
    "ja": "static-7.784",
    "ko": "static-7.784",
    "lt": "static-7.784",
    "ms": "static-7.784",
    "nl": "static-7.784",
    "no": "static-7.784",
    "pl": "static-7.784",
    "pt-br": "static-7.784",
    "pt-pt": "static-7.784",
    "ro": "static-7.784",
    "ru": "static-7.784",
    "sk": "static-7.784",
    "sl": "static-7.784",
    "sv": "static-7.784",
    "th": "static-7.784",
    "tl": "static-7.784",
    "tr": "static-7.784",
    "uk": "static-7.784",
    "vi": "static-7.784",
    "x-pseudo": "static-7.784",
    "zh-cn": "static-7.784",
    "zh-hk": "static-7.784",
    "zh-tw": "static-7.784"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.784'}); }
})();


